export default __webpack_public_path__ + "static/media/movies.61e2ac12.jpg";